module.exports = __webpack_public_path__ + "assets/img/4bcd-gb-nir.svg";